export default class Method
{
    static DELETE = 'delete';
    static GET    = 'get';
    static PATCH  = 'patch';
    static POST   = 'post';
    static PUT    = 'put';
}